import { CreatorDisplaySettingResponse } from "../../api/creatorList";

type CurrencyField = "FinalRateCurrency" | "FinalRateConvertedCurrency";

const readCurrency = (value: unknown): string | undefined => {
	if (typeof value === "string") {
		const trimmed = value.trim();
		return trimmed || undefined;
	}

	if (value && typeof value === "object" && "Currency" in value) {
		const currency = (value as { Currency?: unknown }).Currency;
		if (typeof currency === "string") {
			const trimmed = currency.trim();
			return trimmed || undefined;
		}
	}

	return undefined;
};

const getSettingValue = (setting: CreatorDisplaySettingResponse | null | undefined, key: CurrencyField) => {
	const customInfo = setting?.setting?.customInfo as Record<string, unknown> | undefined;
	const rootSetting = setting?.setting as Record<string, unknown> | undefined;
	const legacyField = key === "FinalRateCurrency" ? "DefaultRateCurrency" : "DefaultRateConvertedCurrency";

	return (
		readCurrency(customInfo?.[key]) ||
		readCurrency(rootSetting?.[key]) ||
		readCurrency(customInfo?.[legacyField]) ||
		readCurrency(rootSetting?.[legacyField])
	);
};

export const getFinalRateCurrencies = (
	setting: CreatorDisplaySettingResponse | null | undefined,
): { finalRateCurrency: string; finalRateConvertedCurrency: string } => ({
	finalRateCurrency: getSettingValue(setting, "FinalRateCurrency") || "USD",
	finalRateConvertedCurrency: getSettingValue(setting, "FinalRateConvertedCurrency") || "AUD",
});
